import nominationsApi from '@/services/api/nominations'

export default {
  namespaced: true,
  state: () => ({
    lists: null,
    defaultList: 'unprocessed'
  }),
  mutations: {
    SET_LISTS(state, { items, defaultList }) {
      state.lists = items
      state.defaultList = defaultList
    }
  },
  actions: {
    async fetchLists({ state, commit }) {
      if (state.lists !== null) return
      const res = await nominationsApi.getLists()
      const data = res.data.data
      commit('SET_LISTS', { items: data.items, defaultList: data.default })
    }
  },
  getters: {
    listItems: (state) => {
      if (state.lists !== null) return state.lists
      return [
        { value: 'unprocessed', label: 'Unprocessed' },
        { value: 'accept', label: 'Accepted' },
        { value: 'waitlist', label: 'Waitlist' },
        { value: 'scratched', label: 'Scratched' }
      ]
    },
    defaultList: state => state.defaultList
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/nominations.js